const socialmedia = {
  props: ['visible', 'accounts', 'type', 'count'],
  computed: {
    ruleName () {
      return {
        title: '标题',
        keywords: '关键词',
        description: '描述'
      }[this.type]
    },
    titleEmpty () {
      return this.type === 'title' && !this.count
    },
    validationList () {
      const valid = []; const invalid = []
      this.accounts.forEach((ac) => {
        if (
          (ac.account.length && ac.isChecked) ||
                    (ac.jujiao_account.length && ac.jujiao_isChecked && ac.jujiao_isShow)
        ) {
          const rules = ac.rules
          const typeRule = rules && rules[this.type]
          if (typeRule) {
            const limit = typeRule.limit
            const obj = {
              limit,
              icon: ac.icon,
              media: +ac.media
            }
            if (this.titleEmpty) {
              invalid.push(obj)
            } else if (!limit || limit >= this.count) {
              valid.push(obj)
            } else {
              invalid.push(obj)
            }
          }
        }
      })

      return {
        valid,
        invalid,
        total: valid.length + invalid.length
      }
    }
  },
  render (h) {
    return h('div', {
      class: 'onlysocial_view_box'
    }, [this.validationList
      ? [
          h('div', {
            class: 'social-media-popover__list onlysocial'
          },
          [this.validationList.valid.map((item, i) => h('div', {
            class: 'social-media-popover__item onlysocial',
            key: i
          }, [
            h('span', {
              class: 'release_icon',
              style: {
                backgroundImage: `url(${item.icon})`,
                backgroundSize: item.media === 3 ? '29px 20px' : '20px 20px'
              }
            }),
            h('span', {
              class: 'social-media-popover__text'
            }, [
              this.count, '/', item.limit || '∞'
            ])
          ])),
          this.validationList.invalid.map((item, i) => h('div', {
            class: 'social-media-popover__item social-media-popover__item--invalid onlysocial',
            key: i
          }, [
            h('span', {
              class: 'release_icon',
              style: {
                backgroundImage: `url(${item.icon})`,
                backgroundSize: item.media === 3 ? '29px 20px' : '20px 20px'
              }
            }),
            h('span', {
              class: 'social-media-popover__text'
            }, [
              this.count, '/', item.limit || '∞'
            ])
          ]))]
          )
        ]
      : []
    ])
  },
  mounted () {
    console.log(this.accounts)
  }
}
export default socialmedia
